<template>
    <div>
        <div class="cell"  v-for="(item, index) in businessList" @click="selectBusiness(item.id)">
            <van-cell is-link>
                <template slot="title">
<!--                    <img :src="item.pic_url" alt="" class="cell-img">-->
                    <div class="custom-title">{{item.name}}</div>
                    <div class="van-cell__label">{{item.desc}}</div>
                </template>
            </van-cell>
        </div>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
</template>
<style scoped>
     .cell-img {
        width: 48px;
        height: 48px;
        float: left;
        border-radius: 50%;
        margin-right: 15px;
    }

    .van-cell__right-icon {
        line-height: 48px;
    }

</style>

<script>
    import Vue from 'vue';
    import {Cell, CellGroup, Toast} from 'vant';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Toast);
    export default {
        name: 'WeiyuanhuiList',
        components: {LoginDialog},
        data: function () {
            return {
                businessList: [],
                loginShow: false,

            }
        },
        filter: {},
        mounted() {
            document.title = "省市管理"
            this.getBussinessList();
        },
        destroyed() {
        },
        methods: {
            getBussinessList() {
                let that = this;
                that.$api.get('/wyhadminapi/index/userinfo', {}, (res) => {
                    that.businessList = res.data.business_list
                }, (res) => {
                    if (res.code == 401 || res.code == 402) {
                        that.loginShow = true
                    } else {
                        Toast(res.msg)
                    }
                })
            },

            loginSuccess(res) {
                console.log('-------登录成功--------', res);
                this.loginShow = false;
                this.getBussinessList()
            },

            loginCancel() {
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },

            selectBusiness(id) {
                let that = this;
                localStorage.setItem('_business_id', id);
                Toast.success('切换成功')
              rbLink({
                name: 'WeiyuanhuiIndex',
                query: {
                  weiyuanhui_id: id,
                }
              })
                // that.$router.replace({
                //     path: '/businessadmin/index',
                //     query: {
                //         business_id: id,
                //     }
                // })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// WeiyuanhuiList.vue?4c41c69e